import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { EightDReport, UpdateFieldFn } from '../../types/eightd.types';

interface D1TeamFormationProps {
    report: Partial<EightDReport>;
    updateField: UpdateFieldFn;
}

export const D1TeamFormation: React.FC<D1TeamFormationProps> = ({ report, updateField }) => {
    // Helper to add member
    const addMember = () => {
        const currentMembers = report.d0_formation?.teamMembers || [];
        updateField('d0_formation.teamMembers', [...currentMembers, { userId: '', name: '', email: '', role: 'Member' }]);
    };

    const updateMember = (index: number, value: string) => {
        const currentMembers = [...(report.d0_formation?.teamMembers || [])];
        currentMembers[index] = { ...currentMembers[index], name: value };
        updateField('d0_formation.teamMembers', currentMembers);
    };

    const removeMember = (index: number) => {
        const currentMembers = [...(report.d0_formation?.teamMembers || [])];
        currentMembers.splice(index, 1);
        updateField('d0_formation.teamMembers', currentMembers);
    };

    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">D1: Team Formation</h3>
                <p className="text-sm text-gray-600 mb-6">
                    Establish a small group of people with the process/product knowledge to solve the problem.
                </p>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Team Leader
                </label>
                <input
                    type="text"
                    value={report.d0_formation?.teamLeaderName || ''}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50"
                />
            </div>

            <div>
                <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Team Members
                    </label>
                    <button
                        onClick={addMember}
                        className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1"
                    >
                        <Plus size={14} /> Add Member
                    </button>
                </div>

                <div className="space-y-2">
                    {(report.d0_formation?.teamMembers || []).map((member, index) => (
                        <div key={index} className="flex gap-2">
                            <input
                                type="text"
                                value={member.name}
                                onChange={(e) => updateMember(index, e.target.value)}
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Member Name & Role"
                            />
                            <button
                                onClick={() => removeMember(index)}
                                className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    ))}
                    {(report.d0_formation?.teamMembers || []).length === 0 && (
                        <p className="text-sm text-gray-500 italic">No additional team members added.</p>
                    )}
                </div>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mt-4">
                <h4 className="font-medium text-blue-800 mb-2">Team Competence</h4>
                <p className="text-sm text-blue-700">
                    Ensure team represents Cross-Functional capabilities (Design, Manufacturing, Quality, etc.) as required by the problem.
                </p>
            </div>
        </div>
    );
};
